import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { UnknownIntent } from '@debbie/common/dist/intents/index.js';
export const emailInitialState = {
    editorState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
    subjectEditorState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
    subject: '',
    to: '',
    from: '',
    loading: false,
    templateName: '',
    templateId: '',
    intent: UnknownIntent(),
};
export const letterInitialState = {
    editorState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
    templateId: '',
    templateName: '',
    templateFileName: '',
    letterTo: '',
    loading: false,
    intent: UnknownIntent(),
};
export const eboksInitialState = {
    editorState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
    subjectEditorState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
    templateId: '',
    templateName: '',
    loading: false,
    intent: UnknownIntent(),
};
export const phoneInitialState = {
    editorState: '',
    phone: null,
    loading: false,
    direction: null,
};
export const smsInitialState = {
    editorState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
    templateId: '',
    templateName: '',
    loading: false,
    intent: UnknownIntent(),
};
export const autocallInitialState = {
    countryCode: 45,
    editorState: convertToRaw(EditorState.createEmpty().getCurrentContent()),
    templateId: '',
    templateName: '',
    loading: false,
    toNumber: '',
    actions: [],
};
export const noteInitialState = {
    editorState: '',
    loading: false,
    attachements: [],
};
export const initialState = {
    letter: {
        ...letterInitialState,
        editorState: EditorState.createWithContent(convertFromRaw(letterInitialState.editorState)),
    },
    eboks: {
        ...eboksInitialState,
        editorState: EditorState.createWithContent(convertFromRaw(eboksInitialState.editorState)),
        subjectEditorState: EditorState.createWithContent(convertFromRaw(eboksInitialState.subjectEditorState)),
    },
    note: noteInitialState,
    // @ts-ignore
    phone: phoneInitialState,
    sms: {
        ...smsInitialState,
        editorState: EditorState.createWithContent(convertFromRaw(smsInitialState.editorState)),
    },
    autocall: {
        ...autocallInitialState,
        editorState: EditorState.createWithContent(convertFromRaw(autocallInitialState.editorState)),
    },
    email: {
        ...emailInitialState,
        editorState: EditorState.createWithContent(convertFromRaw(emailInitialState.editorState)),
        subjectEditorState: EditorState.createWithContent(convertFromRaw(emailInitialState.subjectEditorState)),
    },
    uploadQueue: [],
    uploadedFiles: [],
};
//# sourceMappingURL=types.js.map